import { render, staticRenderFns } from "./InspirationListCard.vue?vue&type=template&id=65c813f7"
import script from "./InspirationListCard.vue?vue&type=script&lang=ts"
export * from "./InspirationListCard.vue?vue&type=script&lang=ts"
import style0 from "./InspirationListCard.vue?vue&type=style&index=0&id=65c813f7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports